import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-progressbar",
  templateUrl: "./html/bfx-progressbar.html",
  styleUrls: [],
  standalone: false,
})
export class BfxProgressBarComponent implements OnInit {
  @Input() value: any = 1;
  // value of the progressbar from 1 to 100 on what value progressbar starts
  @Input() type: string = "success";
  // type what type of progressbar is loaded values: success and warning
  @Input() showValue: boolean = true;
  // show value of the progressbar if false value is not shown
  @Input() unit: any = "%";
  // unit of the progressbar
  @Input() showLabel: boolean = false;
  // if showLabel is selected user needs to add label
  // if showLabel is true showValue and unit will not be visible
  @Input() label: any = "";
  // label or name the progressbar
  @Input() autoValue: boolean = false;
  // if autoValue is true progressbar will autoload with params autoValueSpeed and autoValueInterval
  @Input() autoValueSpeed: number = 50;
  // how to change percentige value starts at 1
  @Input() autoValueInterval: number = 2;
  // time of execution of the progressbar in milliseconds
  displayValue = 0;
  // display progressbar value with no decimals
  // example1: <bfx-progressbar [autoValue]=true [value]=50 [autoValueInterval]=20 [autoValueSpeed]=10 type="seccess"></bfx-progressbar>
  // example2: <bfx-progressbar [autoValue]=true [value]=50 [showLabel]=true label="automation..." type="warning" [autoValueInterval]=10 [autoValueSpeed]=50></bfx-progressbar>

  constructor() {}

  ngOnInit() {
    if (this.autoValue === true) {
      let interval = setInterval(() => {
        this.value = this.value + Math.floor(Math.random() * this.autoValueSpeed) + 1;
        this.displayValue = this.value.toFixed();
        if (this.value >= 100) {
          this.value = 100;
          this.displayValue = this.value.toFixed();
          clearInterval(interval);
        }
      }, this.autoValueInterval);
    }
    if (this.type !== "success" && this.type !== "warning") {
      this.type = "success";
    }
  }

  ngOnChanges(changes) {
    if (
      changes.value &&
      changes.value.currentValue !== null &&
      typeof changes.value.currentValue === "number" &&
      changes.value.currentValue > 0 &&
      changes.value.currentValue !== Number.POSITIVE_INFINITY &&
      this.showLabel === false
    ) {
      this.displayValue = changes.value.currentValue.toFixed();
    }
  }
}
